// link focus
// fix for problem described here https://axesslab.com/skip-links/
// taken from https://github.com/selfthinker/dokuwiki_template_writr/blob/master/js/skip-link-focus-fix.js
import ScrollToHelper from './ScrollToHelper';

class LinkFocusHelper {
    static focusOnElement(elementId, considerPageHeader) {
        const element = document.getElementById(elementId);

        if (!element) {
            return;
        }

        const focusable = (element.tabIndex
            || (element.tagName === 'INPUT' && !element.disabled)
            || (element.tagName === 'A' && element.href)
            || (element.tagName === 'AREA' && element.href)
            || element.tagName === 'OBJECT')
            && !element.hidden;

        if (!focusable) {
            // add tabindex to make focusable and remove again
            element.tabindex = -1;
            const removeTabIndex = () => {
                element.removeAttribute('tabindex');
                element.removeEventListener('blur focusout', removeTabIndex);
            };
            element.addEventListener('blur focusout', removeTabIndex);
        }

        let fixedHeaderHeight = 0;
        if (considerPageHeader) {
            fixedHeaderHeight = document.querySelector('.page-header__content-container').offsetHeight;
        }

        requestAnimationFrame(() => {
            ScrollToHelper.scrollTo(element, fixedHeaderHeight);
        });
        element.focus();
    }

    static handleHashLink() {
        // if there is a '#' in the URL (someone linking directly to a page with an anchor)
        if (document.location.hash) {
            if (!document.location.hash.includes('#/')) {
                const hash = `${document.location.hash.replace(/^#/, '')}`;
                LinkFocusHelper.focusOnElement(hash, true);
            }
        }

        // if the hash has been changed (activation of an in-page link)
        window.addEventListener('hashchange', () => {
            const hash = `${window.location.hash.replace(/^#/, '')}`;
            LinkFocusHelper.focusOnElement(hash, false);
        });
    }
}

export default LinkFocusHelper;
